import "core-js/modules/es.array.push.js";
import { useModel as _useModel, mergeModels as _mergeModels } from 'vue';
import { mergeProps as _mergeProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, toHandlers as _toHandlers, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "search-bar-form-inner-wrapper"
};
const _hoisted_2 = {
  key: 0,
  class: "search-bar-form-footer"
};
import { reactive, ref, watch } from 'vue';
export default {
  __name: 'mg-search-bar',
  props: /*@__PURE__*/_mergeModels({
    items: {
      type: Array,
      default: () => []
    },
    showButtons: {
      type: Boolean,
      default: true
    }
  }, {
    "collapse": {
      default: true
    },
    "collapseModifiers": {}
  }),
  emits: /*@__PURE__*/_mergeModels(['search', 'resetSearch'], ["update:collapse"]),
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const emit = __emit;
    const formRef = ref();
    const props = __props;
    const collapse = _useModel(__props, 'collapse');
    const searchFormProps = reactive({
      titleColon: true,
      titleAlign: 'left',
      data: {}
    });
    const searchFormEvents = {
      submit() {
        const params = {
          ...searchFormProps.data
        };
        emit('search', params);
      },
      reset() {
        emit('resetSearch');
      },
      collapse({
        status,
        data
      }) {
        console.log('collapse', {
          status,
          data
        });
      }
    };
    const defaultFormItem = {
      itemRender: {
        name: 'VxeButtonGroup',
        options: [{
          type: 'submit',
          content: '搜索',
          icon: 'vxe-icon-search'
        }, {
          type: 'reset',
          content: '重置',
          icon: 'vxe-icon-reset'
        }]
      }
    };
    const formItems = ref([]);
    watch(() => props.items, val => {
      formItems.value = [...val];
      if (props.showButtons && Array.isArray(val) && val.length > 0) {
        formItems.value.push(defaultFormItem);
      }
    }, {
      immediate: true,
      deep: true
    });
    __expose({
      submit: () => {
        collapse.value = true;
        searchFormEvents.submit();
      },
      reset: () => {
        !!formRef.value && formRef.value.reset();
      },
      'toggleCollapse'() {
        collapse.value = !collapse.value;
      }
    });
    return (_ctx, _cache) => {
      const _component_vxe_form = _resolveComponent("vxe-form");
      const _component_vxe_button = _resolveComponent("vxe-button");
      const _component_vxe_button_group = _resolveComponent("vxe-button-group");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['search-bar-form-wrapper', {
          'is--expend': !collapse.value
        }])
      }, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_vxe_form, _mergeProps({
        ref_key: "formRef",
        ref: formRef,
        items: formItems.value
      }, searchFormProps, _toHandlers(searchFormEvents), {
        "collapse-status": collapse.value,
        "onUpdate:collapseStatus": _cache[0] || (_cache[0] = $event => collapse.value = $event)
      }), _createSlots({
        _: 2
      }, [_renderList(Object.keys(_ctx.$slots), key => {
        return {
          name: key,
          fn: _withCtx(scope => [_renderSlot(_ctx.$slots, key, _mergeProps({
            key: key
          }, scope))])
        };
      })]), 1040, ["items", "collapse-status"]), !collapse.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_vxe_button_group, {
        size: "mini"
      }, {
        default: _withCtx(() => [_createVNode(_component_vxe_button, {
          status: "success",
          icon: "vxe-icon-search",
          onClick: _cache[1] || (_cache[1] = () => searchFormEvents.submit())
        }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("搜索", -1)]))]),
          _: 1
        }), _createVNode(_component_vxe_button, {
          icon: "vxe-icon-reset",
          onClick: _cache[2] || (_cache[2] = () => searchFormEvents.reset())
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("重置", -1)]))]),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("span", {
        class: "btn-toggle-collapse",
        onClick: _cache[3] || (_cache[3] = $event => collapse.value = !collapse.value)
      }, [...(_cache[6] || (_cache[6] = [_createElementVNode("span", null, "收缩", -1), _createElementVNode("i", {
        class: "vxe-icon-arrow-up"
      }, null, -1)]))])])) : _createCommentVNode("", true)])], 2);
    };
  }
};